define(['jQuery',
        'library/fcse-compatibility/object',
        'clientComponents/googletagmanager/GtmBase'],
    /**
     * @returns {GtmHomePage}
     */
    function ($, Object, GtmBase) {

        function GtmHomePage(options) {
            GtmBase.apply(this, arguments);
            $('body').on('click', '[data-gtm-product]', $.proxy(this._onTeaserClick, this));
        }

        GtmHomePage.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmHomePage.prototype */{
            _onTeaserClick: function (event) {
                try {
                    const $teaser = $(event.target).closest('[data-gtm-product]');
                    const targetUrl = $teaser.find('a').first().attr('href');
                    let redirectFunction = function() {};

                    if (targetUrl && !(/^#.*/i).test(targetUrl)) {
                        event.preventDefault();
                        redirectFunction = function() {
                            document.location = targetUrl
                        };
                    }

                    window.setTimeout(redirectFunction, 2000);
                    const promotionEvent = {
                        'event': 'promotionClick',
                        'promotion': {
                            id: $teaser.data('cms-module-id'),
                            name: $teaser.data('gtm-teaser-title'),
                            creative: $teaser.data('gtm-teaser-title')
                        },
                        eventCallback: redirectFunction
                    };

                    return this.trackEvent(promotionEvent);
                } catch (e) {
                    console.log(e);
                }
            },
            trackPage: function () {
                const data = {
                    promotions: this.getPagePromotions(),
                    products: this.getPageProducts()
                };

                return this.trackData(data);
            },
            getPagePromotions: function () {
                const teasers = [];
                $('[data-gtm-product]').each(function (index, teaser) {
                    const $teaser = $(teaser);
                    teasers.push({
                        id: $teaser.data('gtm-teaser-id'),
                        name: $teaser.data('gtm-teaser-title'),
                        creative: $teaser.data('gtm-teaser-title'),
                        position: index
                    });
                });
                return teasers;
            },
            getPageProducts: function () {
                const products = [];
                $('[data-gtm-product]').each(function (index, product) {
                    const productData = JSON.parse(atob($(product).data('gtm-product')));
                    products.push(productData);
                });
                return products;
            }
        });

        return GtmHomePage;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/googletagmanager/GtmHomePage.js